export default "__VITE_ASSET__9c323297__"